import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import HttpClientXml from "../../../utils/HttpClientXml";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const AddStaff = () => {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [cities, setCities] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [roles, setRoles] = useState([
    {
      _id: 1,
      name: "sales",
    },
    {
      _id: 2,
      name: "survey",
    },
    {
      _id: 3,
      name: "telecalling",
    },
    {
      _id: 4,
      name: "data entry",
    },
    {
      _id: 5,
      name: "branch manager",
    },
    {
      _id: 6,
      name: "freelancer",
    },
  ]);

  const [logo, setLogo] = useState("");
  const [image, setImage] = useState("");

  const [uploading, setUploading] = useState(false);

  const initialFormData = {
    name: "",
    email: "",
    city: "",
    role: "",
    qualification: "",
    designation: "",
    phoneNo: 0,
    salary: 0,
    photo: "",
    password: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const navigate = useNavigate();

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  // Fetch Designations
  const fetchDesignations = async () => {
    try {
      const res = await HomeService.getDesignations();
      if (res?.data) {
        setDesignations(res.data);
      }
    } catch (error) {
      console.error("Error fetching designations:", error);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();

    let name = e.target.name;
    let value = e.target.value;

    if (name === "phoneNo" || name === "salary") {
      value = parseInt(value);
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleFileUpload = async (e) => {
    setUploading(true);
    const file = e.target.files[0];
    const data = new FormData();
    data.append("image", file);

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setFormData({ ...formData, [e.target.name]: res.image });
        setUploading(false);
      }
    } catch (error) {
      toast.error(`Upload Failed.`);
      console.error(`Error uploading:`, error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("data", formData);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData?.email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    if (formData?.phoneNo?.toString()?.length !== 10) {
      toast?.error("Contact Number should be in 10 digits");
      return;
    }

    try {
      const res = await HomeService.addStaff(formData);
      if (res?.status) {
        toast.success("Staff added successfully!");
        setFormData(initialFormData);
        navigate("/manage-staff");
      }
    } catch (error) {
      toast.error("Failed to add staff.");
      console.error("Error adding staff:", error);
    }
  };

  useEffect(() => {
    setRoles(roles.filter((role) => role.name !== userRole));
    fetchCities();
    fetchDesignations();
  }, []);

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <h2 className="text-center" style={headLineStyle}>
            Add Staff
          </h2>

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  {uploading ? (
                    <>
                      <label>
                        <span className="text-success">Uploading...</span>
                      </label>
                    </>
                  ) : formData.photo ? (
                    <></>
                  ) : (
                    <>
                      <label>Photo</label>
                    </>
                  )}
                  {formData.photo && (
                    <div className="mb-2">
                      <img
                        src={formData.photo}
                        alt="Logo Preview"
                        width="100"
                        style={{ display: "block", marginTop: "10px" }}
                      />
                    </div>
                  )}
                  <input
                    type="file"
                    name="photo"
                    className="form-control"
                    onChange={(e) => handleFileUpload(e)}
                    accept="image/*"
                  />
                </div>

                <div
                  className="col-md-6 mt-3"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                  }}
                >
                  <label>
                    Full Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData?.name}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Full Name"
                    required
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <label>
                    Email Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData?.email || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Email address"
                    required
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <label>
                    Password<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="password"
                    value={formData?.password || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Password"
                    required
                  />
                </div>

                <div className="col-md-4 mt-3">
                  <label>
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="city"
                    value={formData?.city || ""}
                    onChange={(e) => handleChange(e)}
                    required
                  >
                    <option value="" disabled>
                      ---Select---
                    </option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4 mt-3">
                  <label>
                    Role<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="role"
                    value={formData?.role || ""}
                    onChange={(e) => handleChange(e)}
                    required
                  >
                    <option value="" disabled>
                      ---Select---
                    </option>
                    {roles.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4 mt-3">
                  <label>
                    Designation<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="designation"
                    value={formData?.designation || ""}
                    onChange={(e) => handleChange(e)}
                    required
                  >
                    <option value="" disabled>
                      ---Select---
                    </option>
                    {designations.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3 mt-3">
                  <label>
                    Salary<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="salary"
                    value={formData?.salary || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter salary"
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Qualification<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="qualification"
                    value={formData?.qualification || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter qualification"
                    required
                  />
                </div>

                <div className="col-md-3 mt-3">
                  <label>
                    Contact Number<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="phoneNo"
                    value={formData?.phoneNo || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter phone number"
                    required
                  />
                </div>
              </div>
              <button
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                }}
                type="submit"
                className="btn mt-3"
              >
                Submit
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AddStaff;
